import gql from 'graphql-tag'
import {internalStatus} from "../../Constants/Constant";

let cities = JSON.parse(localStorage.getItem('cities'))
let finalCondition = '';
let pickupFinalCondition = '';
let dropFinalCondition = '';
let pickup_drop_finalCondition = '';
let intermediateCondition = '';
let pickupIntermediateCondition = '';
let dropIntermediateCondition = '';
let pickup_drop_intermediateCondition = '';
if(cities && cities.length){
  cities.forEach(function(curnt){
    let clientStr = '{clientobject: {_contains: {address:[{city: "'+ curnt.city +'"}]}}},'
    let pickupStr = '{pickuppartyobject: {_contains: {address:[{city: "'+ curnt.city +'"}]}}},'
    let dropStr = '{droppingpartyobject: {_contains: {address:[{city: "'+ curnt.city +'"}]}}},'
    intermediateCondition = intermediateCondition + clientStr + pickupStr + dropStr
    pickupIntermediateCondition = pickupIntermediateCondition + pickupStr
    dropIntermediateCondition = dropIntermediateCondition + dropStr
    pickup_drop_intermediateCondition = pickup_drop_intermediateCondition + pickupStr + dropStr
  })
  finalCondition = ', {_or: ['+ intermediateCondition +']}'
  pickupFinalCondition = ', {_or: ['+ pickupIntermediateCondition +']}'
  dropFinalCondition = ', {_or: ['+ dropIntermediateCondition +']}'
  pickup_drop_finalCondition = ', {_or: ['+ pickup_drop_intermediateCondition +']}'
}
export const SUBSCRIBE_ORDERS = gql`
subscription ($startDate:timestamptz!, $endDate:timestamptz!, $priority: [Int!]){
  orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},{ priority: {_in: $priority}}${finalCondition}]}){
    id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
  }
}
`

export const SUBSCRIBE_KANBAN_ORDERS = gql`
subscription ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
  orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] }${finalCondition}]}){
    id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails {id pickupPoint dropPoint}
  }
}
`
export const SUBSCRIBE_SINGLE_ORDER = gql`
subscription orders($orderId:uuid!){
  orders (where: {id: {_eq: $orderId}}){
      id
      pickupDate
      createdAt
      updated_at
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalStatus{ name id}
      externalStatus{ name id}
      orderDetails {
        id
        lrObject
        dispactchVerification
        orderReadiness
        pickupConfirmation
        pickupPoint
        dropPoint
        loadedInTruck
        ewayBillNo
        isEwayBillVerified
        pickupVehicleAssignId
        materialSize
        cancellationReason
        PIckupTempo{
           id
           tempo {id name platNo}
           driverDetail {id name mobile}
          }
        PickupTruck{
           id
           truck {id name platNo}
           driverDetail {id name mobile}
          }
        transportVehicleAssignId
        truckOrder{
           id
           truck {id name platNo}
           driverDetail {id name mobile}
          }
       }
  }
}

`
export const SUBSCRIBE_UNPICKED_ORDERS = gql`
subscription orderDetails{
  orderDetails (where: {pickupVehicleAssignId: {_eq: null}}){
       order {
        id
        pickupDate
        clientobject
        pickuppartyobject
        droppingpartyobject
        materials
        priority
        note
        orderNumber
        internalstatus
        externalstatus
      }
  }
}
`

export const SUBSCRIBE_ORDER_NOTE_HISTORY = gql`
subscription notes($orderId:uuid!){
  notes(where: {orderId: {_eq: $orderId}}, order_by: {createdOn: desc}) {
    id
    note
    type
    CreatedBy{id name}
    createdOn
  }
}
`

export const ORDER_FRAGMENT_PROCESS_ORDERS = gql`
fragment order on orders {
      id
      clientobject
      pickuppartyobject
      droppingpartyobject
      orderNumber
      pickupDate
      createdAt
      updated_at
      materials
      priority
      lastStageUpdatedOn
      note
      notes(order_by: {createdOn: desc}, limit: 1){id note}
      internalstatus
      internalStatus{id name viewPath}
      externalstatus
      LRs {id lrNumber status}
      orderDetails {
        id
        lrObject
        pickupConfirmation
        orderReadiness
        dispactchVerification
        pickupVehicleAssignId
        transportVehicleAssignId
        loadedInTruck
        ewayBillNo
        isEwayBillVerified
        carryBill
        pickupPoint
        dropPoint
        materialSize
        PIckupTempo{
           id
           tempo {id platNo}
           driverDetail {id name mobile }
          }
        PickupTruck{
           id
           lrCommision
           price
           truck {id platNo}
           Transporter {id name mobile}
           driverDetail {id name  mobile}
          }
        truckOrder{
           id
           lrCommision
           price
           truck {id platNo}
           Transporter {id name mobile}
           driverDetail {id name mobile}
          }
      }
}`

export const SUBSCRIBE_ALL_ORDERS = gql`
  subscription ($searchFilter: String!, $lrName: jsonb!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
    orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},{internalstatus: {_neq: "912cba99-37cb-41fb-ae2e-2a472200af64"}},
    {internalstatus: {_neq: "ed2747e7-c86b-48c7-96db-b10c509c27cf"}},{internalstatus: {_neq: "24e00980-9a93-496c-b422-7b17a9ddfc2a"}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}},{orderDetails: {lrObject: {_contains: $lrName}}}] }${finalCondition}]}, order_by: {createdAt: desc}){
      ...order
    }
  }${ORDER_FRAGMENT_PROCESS_ORDERS}`

export const SUBSCRIBE_COMPLETED_ORDERS = gql`
subscription ($searchFilter: String!, $lrName: jsonb!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
  orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},{internalstatus: {_eq: "ed2747e7-c86b-48c7-96db-b10c509c27cf"}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}, {NewPickupDropParty: {name: {_ilike: $searchFilter}}}, {orderDetails: {lrObject: {_contains: $lrName}}}] }${finalCondition}]}, order_by: {pickupDate: desc}){
      ...order
  }
}${ORDER_FRAGMENT_PROCESS_ORDERS}`

export const SUBSCRIBE_CANCEL_ORDERS = gql`
subscription ($searchFilter: String!, $lrName: jsonb!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
  orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},{internalstatus: {_eq: "24e00980-9a93-496c-b422-7b17a9ddfc2a"}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}, {NewPickupDropParty: {name: {_ilike: $searchFilter}}}, {orderDetails: {lrObject: {_contains: $lrName}}}] }${finalCondition}]}, order_by: {pickupDate: desc}){
     ...order
  }
}${ORDER_FRAGMENT_PROCESS_ORDERS}`

export const SUBSCRIBE_REJECTED_ORDERS = gql`
subscription ($searchFilter: String!, $lrName: jsonb!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
  orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},{internalstatus: {_eq: "912cba99-37cb-41fb-ae2e-2a472200af64"}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}},{orderDetails: {lrObject: {_contains: $lrName}}}] }${finalCondition}]}, order_by: {pickupDate: desc}){
     ...order
  }
}${ORDER_FRAGMENT_PROCESS_ORDERS}`

export function generate_PICKUP_PROCESS_ORDERS_CITYWISE(type = 'query') {
  return gql`
  ${type} pickup_process_orders_cityWise($searchFilter: String!, $selectedAreaGroups: [String!], $lrName: jsonb!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
    pickup_orders: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
    {internalstatus: {_in: [${internalStatus.pendingForApproval},${internalStatus.pendingForOrderConfirmation},${internalStatus.orderNotReady},
        ${internalStatus.underPickupProcess},${internalStatus.readyForPickup},${internalStatus.tempoOnTheWayToPickupLoad},${internalStatus.tempoWaitingForLoadingMaterial},
        ${internalStatus.underBillingProcess},${internalStatus.onTheWayToPickupCityWarehouse},${internalStatus.underVerificationAtPickupCityWarehouse},
        ${internalStatus.inProcessOfDeparture},${internalStatus.waitingForDeparture}]}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderDetails: {pickupAreaGroup: {_in: $selectedAreaGroups}}},{orderDetails: {dropAreaGroup: {_in: $selectedAreaGroups}}} ]},
     {_or: [{orderNumber: {_ilike: $searchFilter}}, {Client: {name: {_ilike: $searchFilter}}},{orderDetails: {ewayBillNo: {_ilike: $searchFilter}}},
     {Client: {mobile: {_ilike: $searchFilter}}},{PickupParty: {mobile: {_ilike: $searchFilter}}},{DropParty: {mobile: {_ilike: $searchFilter}}},
     {orderDetails: {truckOrder: {truck: {platNo: {_ilike: $searchFilter}}}}},
     {orderDetails: {PIckupTempo: {tempo: {platNo: {_ilike: $searchFilter}}}}},{orderDetails: {PickupTruck: {truck: {platNo: {_ilike: $searchFilter}}}}},
     {orderDetails: {truckOrder: {driverDetail: {name: {_ilike: $searchFilter}}}}},{orderDetails: {truckOrder: {driverDetail: {mobile: {_ilike: $searchFilter}}}}},
     {orderDetails: {PIckupTempo: {driverDetail: {name: {_ilike: $searchFilter}}}}},{orderDetails: {PIckupTempo: {driverDetail: {mobile: {_ilike: $searchFilter}}}}},
     {orderDetails: {PickupTruck: {driverDetail: {name: {_ilike: $searchFilter}}}}},{orderDetails: {PickupTruck: {driverDetail: {mobile: {_ilike: $searchFilter}}}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}, {NewPickupDropParty: {name: {_ilike: $searchFilter}}}, {orderDetails: {lrObject: {_contains: $lrName}}}] }
     ${pickupFinalCondition}]}, order_by: {internalStatus: {sequenceNumber: asc_nulls_last}, createdAt: desc}){
     ...order
    }
  }${ORDER_FRAGMENT_PROCESS_ORDERS}`
}

export function generate_DELIVERY_PROCESS_ORDERS_CITYWISE(type = 'query') {
  return gql`
  ${type} delivery_process_orders_cityWise($searchFilter: String!, $selectedAreaGroups: [String!], $lrName: jsonb!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
    delivery_orders: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {internalstatus: {_in: [${internalStatus.onTheWayToDropCityWarehouse},${internalStatus.atDestinationCityWarehouse},${internalStatus.readyForFinalDelivery}]}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderDetails: {pickupAreaGroup: {_in: $selectedAreaGroups}}},{orderDetails: {dropAreaGroup: {_in: $selectedAreaGroups}}} ]},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},{orderDetails: {ewayBillNo: {_ilike: $searchFilter}}},
     {Client: {mobile: {_ilike: $searchFilter}}},{PickupParty: {mobile: {_ilike: $searchFilter}}},{DropParty: {mobile: {_ilike: $searchFilter}}},
     {orderDetails: {truckOrder: {truck: {platNo: {_ilike: $searchFilter}}}}},
     {orderDetails: {PIckupTempo: {tempo: {platNo: {_ilike: $searchFilter}}}}},{orderDetails: {PickupTruck: {truck: {platNo: {_ilike: $searchFilter}}}}},
     {orderDetails: {truckOrder: {driverDetail: {name: {_ilike: $searchFilter}}}}},{orderDetails: {truckOrder: {driverDetail: {mobile: {_ilike: $searchFilter}}}}},
     {orderDetails: {PIckupTempo: {driverDetail: {name: {_ilike: $searchFilter}}}}},{orderDetails: {PIckupTempo: {driverDetail: {mobile: {_ilike: $searchFilter}}}}},
     {orderDetails: {PickupTruck: {driverDetail: {name: {_ilike: $searchFilter}}}}},{orderDetails: {PickupTruck: {driverDetail: {mobile: {_ilike: $searchFilter}}}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}, {NewPickupDropParty: {name: {_ilike: $searchFilter}}}, {orderDetails: {lrObject: {_contains: $lrName}}}] }
     ${dropFinalCondition}]}, order_by: {internalStatus: {sequenceNumber: asc_nulls_last}, createdAt: desc}){
      ...order
    }
  }${ORDER_FRAGMENT_PROCESS_ORDERS}`
}

export function generate_OPEN_PROCESS_ORDERS_CITYWISE(type = 'query') {
  return gql`
  ${type} open_process_orders_cityWise($searchFilter: String!, $selectedAreaGroups: [String!], $lrName: jsonb!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
    open_orders: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {internalstatus: {_neq: ${internalStatus.completed}}},{internalstatus: {_neq: ${internalStatus.cancel}}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderDetails: {pickupAreaGroup: {_in: $selectedAreaGroups}}},{orderDetails: {dropAreaGroup: {_in: $selectedAreaGroups}}} ]},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},{orderDetails: {ewayBillNo: {_ilike: $searchFilter}}},
     {Client: {mobile: {_ilike: $searchFilter}}},{PickupParty: {mobile: {_ilike: $searchFilter}}},{DropParty: {mobile: {_ilike: $searchFilter}}},
     {orderDetails: {truckOrder: {truck: {platNo: {_ilike: $searchFilter}}}}},
     {orderDetails: {PIckupTempo: {tempo: {platNo: {_ilike: $searchFilter}}}}},{orderDetails: {PickupTruck: {truck: {platNo: {_ilike: $searchFilter}}}}},
     {orderDetails: {truckOrder: {driverDetail: {name: {_ilike: $searchFilter}}}}},{orderDetails: {truckOrder: {driverDetail: {mobile: {_ilike: $searchFilter}}}}},
     {orderDetails: {PIckupTempo: {driverDetail: {name: {_ilike: $searchFilter}}}}},{orderDetails: {PIckupTempo: {driverDetail: {mobile: {_ilike: $searchFilter}}}}},
     {orderDetails: {PickupTruck: {driverDetail: {name: {_ilike: $searchFilter}}}}},{orderDetails: {PickupTruck: {driverDetail: {mobile: {_ilike: $searchFilter}}}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}, {NewPickupDropParty: {name: {_ilike: $searchFilter}}}, {orderDetails: {lrObject: {_contains: $lrName}}}] }
     ${finalCondition}]}, order_by: {internalStatus: {sequenceNumber: asc_nulls_last}, createdAt: desc}){
      ...order
    }
  }${ORDER_FRAGMENT_PROCESS_ORDERS}`
}

export const SUBSCRIBE_COMPLETED_PROCESS_ORDERS_CITYWISE = gql`
 subscription completed_process_orders_cityWise($searchFilter: String!, $lrName: jsonb!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
    completed_orders: orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {internalstatus: {_in: [${internalStatus.completed}]}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},{orderDetails: {ewayBillNo: {_ilike: $searchFilter}}},
     {Client: {mobile: {_ilike: $searchFilter}}},{PickupParty: {mobile: {_ilike: $searchFilter}}},{DropParty: {mobile: {_ilike: $searchFilter}}},
     {orderDetails: {truckOrder: {truck: {platNo: {_ilike: $searchFilter}}}}},
     {orderDetails: {PIckupTempo: {tempo: {platNo: {_ilike: $searchFilter}}}}},{orderDetails: {PickupTruck: {truck: {platNo: {_ilike: $searchFilter}}}}},
     {orderDetails: {truckOrder: {driverDetail: {name: {_ilike: $searchFilter}}}}},{orderDetails: {truckOrder: {driverDetail: {mobile: {_ilike: $searchFilter}}}}},
     {orderDetails: {PIckupTempo: {driverDetail: {name: {_ilike: $searchFilter}}}}},{orderDetails: {PIckupTempo: {driverDetail: {mobile: {_ilike: $searchFilter}}}}},
     {orderDetails: {PickupTruck: {driverDetail: {name: {_ilike: $searchFilter}}}}},{orderDetails: {PickupTruck: {driverDetail: {mobile: {_ilike: $searchFilter}}}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}},{orderDetails: {lrObject: {_contains: $lrName}}}] }
     ${pickup_drop_finalCondition}]}, order_by: {internalStatus: {sequenceNumber: asc_nulls_last}, createdAt: desc}){
      ...order
    }
  }${ORDER_FRAGMENT_PROCESS_ORDERS}`

export const SUBSCRIBE_ORDERS_CITYWISE = gql`
subscription orders_cityWise($startDate:timestamptz!, $endDate:timestamptz!, $city:jsonb!){
    orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lt: $endDate}},{internalstatus: {_neq: "912cba99-37cb-41fb-ae2e-2a472200af64"}},
     {_or: [{clientobject: {_contains: $city}}, {pickuppartyobject: {_contains: $city}}, {droppingpartyobject: {_contains: $city}}]}
     ${finalCondition}]}, order_by: {createdAt: desc}){
      ...order
    }
  }${ORDER_FRAGMENT_PROCESS_ORDERS}`
